import React from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from 'lodash';
import { Checkbox, Segment } from 'semantic-ui-react';

import LookUpNavigationContainer from 'PointOfSale/modules/lookup/container/LookUpNavigationContainer';
import GroupTeacherName from 'PointOfSale/modules/groupTeacher/component/GroupTeacherName';
import LastTransactionDetails from 'PointOfSale/modules/common/container/LastTransactionDetails';

const GroupTeacherSideBar = ({ teacher, toggle, toggleSelected }) => {
  return (
    <React.Fragment>
      <div className="flex flex-col">
        <LookUpNavigationContainer />
        {!isEmpty(teacher) && (
          <React.Fragment>
            <GroupTeacherName name={teacher} />
            <Segment basic>
              <Checkbox
                slider
                onClick={toggle}
                checked={toggleSelected}
                label="Select all for checkout"
              />
            </Segment>
          </React.Fragment>
        )}
      </div>

      {!isEmpty(teacher) && <LastTransactionDetails />}
    </React.Fragment>
  );
};

GroupTeacherName.propTypes = {
  teacher: PropTypes.string,
  toggle: PropTypes.func,
  toggleSelected: PropTypes.bool,
};

export default GroupTeacherSideBar;



// WEBPACK FOOTER //
// ./src/pages/pointofsale/modules/groupTeacher/component/GroupTeacherSideBar.js